import React from 'react';
import cx from 'classnames';
import {Flex, Text} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';

export type TwoColumnOptionProps = {
    description?: string;
    value: string;
};

export const TwoColumnOption = (props: TwoColumnOptionProps) => {
    return (
        <Flex justifyContent="flex-start" componentClasses={styles.twoColumnOption}>
            <div className={styles.cell}>
                <Text skin="subtitle-2" textColor="primary-700">
                    {props.value}
                </Text>
            </div>

            <div className={cx(styles.cell, styles.desc)}>
                <Text skin="subtitle-2" textColor="secondary-400">
                    {props.description}
                </Text>
            </div>
        </Flex>
    );
};
